import PropTypes from 'prop-types'

/**
 * Renders text with basic formatting:
 * - Paragraphs (split by double newlines)
 * - Line breaks (single newlines within paragraphs)
 * - Bold text (**text**)
 * - Links ([text](url))
 */
function RichText({ text, className = '' }) {
  if (!text) return null

  // Split into paragraphs by double newlines
  const paragraphs = text.split(/\n\n+/)

  const renderFormattedText = (content) => {
    // Handle links [text](url) and bold text (**text**)
    const parts = content.split(/(\[[^\]]+\]\([^)]+\)|\*\*[^*]+\*\*)/)

    return parts.map((part, index) => {
      // Handle links
      const linkMatch = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/)
      if (linkMatch) {
        return (
          <a
            key={index}
            href={linkMatch[2]}
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:opacity-70"
          >
            {linkMatch[1]}
          </a>
        )
      }
      // Handle bold
      if (part.startsWith('**') && part.endsWith('**')) {
        return <strong key={index}>{part.slice(2, -2)}</strong>
      }
      // Handle single line breaks
      const lines = part.split('\n')
      return lines.map((line, lineIndex) => (
        <span key={`${index}-${lineIndex}`}>
          {line}
          {lineIndex < lines.length - 1 && <br />}
        </span>
      ))
    })
  }

  return (
    <div className={className}>
      {paragraphs.map((paragraph, index) => (
        <p key={index} className="mb-20 last:mb-0">
          {renderFormattedText(paragraph.trim())}
        </p>
      ))}
    </div>
  )
}

RichText.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
}

export default RichText
